import { memo } from 'react';
import { Button, Modal } from 'antd';
import IntlMessages from '../Message/IntlMessages';
import DangerousMessage from 'components/Message/DangerousMessage';

const PWMRegister = ({
  close, actions, state, ...modalProps
}) => {

  function onAccept() {
    close();
    if (actions.onAccept) actions.onAccept()
  }

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="global.krungthai.pwm" />
            </h5>
            <Button className="btn button-ktb-close" onClick={close}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="modal-mnc-body">

            {state.message
              ? <DangerousMessage.Span className="custom-message-1" id="register.body.message" html={state.message} />
              : <IntlMessages id="model.PWM.register.message" />
            }

          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6">
                <div className="d-grid">
                  <Button data-accept-btn type="primary" className="btn button-ktb-main" onClick={onAccept}>
                    <IntlMessages id="global.register" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default memo(PWMRegister);